<div class="container-fluid">
  <app-pagetitle title="Cabinet" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>

<div class="main-card-container">
  <div class="card">
    <div class="card-body">
      <div class="dropdown float-end" ngbDropdown>
        <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
          data-toggle="dropdown" aria-expanded="false">
          <i class="mdi mdi-dots-vertical"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item">Import Cabinets</a>
          <!-- item-->
          <a href="javascript:void(0);" class="dropdown-item">Export Cabinets</a>
  
        </div>
        <i class="mdi mdi-refresh" (click)="refresh()" ngbTooltip="Refresh"></i>
      </div>
      <h4 class="card-title mb-4">Cabinet Table</h4>
      <div class="row">
        <button type="button" class="btn btn-primary" style="height:50px;width:200px;" (click)="onAddNew(addEditModal)">Add New Cabinet</button>
        <button class="nav-button" class="btn btn-secondary" style="height:50px;width:125px;margin-left: 10px;" [routerLink]="'/printerTypes'">Manage Printer Types</button>
        <button class="nav-button" class="btn btn-secondary" style="height:50px;width:125px;margin-left: 10px;" [routerLink]="'/monitorTypes'">Manage Monitor Types</button>
        <button class="nav-button" class="btn btn-secondary" style="height:50px;width:125px;margin-left: 10px;" [routerLink]="'/bvTypes'">Manage Bv Types</button>
        <button class="nav-button" class="btn btn-secondary" style="height:50px;width:125px;margin-left: 10px;" [routerLink]="'/harnessTypes'">Manage Harness Types</button>
        <button class="nav-button" class="btn btn-secondary" style="height:50px;width:125px;margin-left: 10px;" [routerLink]="'/cabinetTypes'">Manage Cabinet Types</button>
       
       
       
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_filter" class="dataTables_filter text-md-end"><label
              class="d-inline-flex align-items-center">Search:
              <input type="text" name="searchTerm" class="form-control form-control-sm ms-2"
                aria-controls="tickets-table" [(ngModel)]="term" /></label></div>
        </div>
      </div>
      <div class="table-responsive" style="max-height: 400px; overflow-y: auto;">
        <table class="table table-centered">
            <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
            <tr>
              <th>Cabinet Tag</th>
              <th>Cabinet Type</th>
              <th>Monitor Type</th>
              <th>BV Type</th>
              <th>Printer Type</th>
              <th>Harness Type</th>
              <th>Board</th>
              <th>Location</th>
              <th>Purchase Date</th>           
              </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of cabinets|filter:term">
              <td>{{item.cabinetTag}}</td>
              <td><span *ngIf="item.cabinetType">{{item.cabinetType?.name}}</span></td>
              <td><span *ngIf="item.monitorType">{{item.monitorType?.name}}</span></td>
              <td><span *ngIf="item.billValidatorType">{{item.billValidatorType?.name}}</span></td>
              <td><span *ngIf="item.printerType">{{item.printerType?.name}}</span></td>
              <td><span *ngIf="item.harnessType">{{item.harnessType?.name}}</span></td>
              <td><span *ngIf="item.board">{{item.board?.assetTag}}: {{item.board?.installedGamePackage?.name}}: {{item.board?.installedGamePackage?.version}}</span></td>
              <td><span *ngIf="item.location">{{item.location?.locationTag}}: {{item.location?.locationName}}</span></td>
              <td>{{item.purchased | date}}</td>
              <td *ngIf="!readonly; else isEnabled" ><input type="checkbox" class="form-check-input" name="enabled"  [checked]="item.enabled"> </td> 
              <ng-template #isEnabled><td>{{item.enabled}}</td></ng-template>
              <td>
                <a *ngIf="!readonly" (click)="onEdit(addEditModal, item)" class="me-3 text-primary" ngbTooltip="Edit" ><i
                    class="mdi mdi-pencil font-size-50"></i></a>
                <a *ngIf="!readonly" (click)="onDelete(item.id)"  class="text-danger" ngbTooltip="Delete"><i
                    class="mdi mdi-trash-can font-size-18"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <ng-template #addEditModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="add-edit-modal-title">{{addEditMode}}</h4>
      <button class="btn btn-warn close" (click)="modal.dismiss('Cross click')">Close</button>
    </div>
    <div class="modal-body">
      <form class="form" [formGroup]="addEditFormGroup">
        <div class="form-group">
          <label for="cabinetTag-input" style="font-size: 20px;" style="font-family: Arial;">Asset Tag</label>
          <input type="text" class="form-control" id="cabinetTag-input" 
            formControlName="cabinetTag"
            aria-describedby="cabinetTag" placeholder="Enter Cabinet Tag">
        </div>
        <div class="form-group">
          <label for="cabinetType-input" style="font-size: 20px;" style="font-family: Arial;">Cabinet Type</label>
          <select class="form-select" id="cabinetType-input"  formControlName="cabinetType">
              <option *ngFor="let v of cabinetType" [value]="v.id">{{v.name}}</option>
          </select>
        </div>   
        <div class="form-group">
          <label for="monitorType-input" style="font-size: 20px;" style="font-family: Arial;">Monitor Type</label>
          <select class="form-select" id="boardType-input"  formControlName="monitorType">
              <option *ngFor="let v of monitorType" [value]="v.id">{{v.name}}</option>
          </select>
        </div>   
        <div class="form-group">
          <label for="billValidatorType-input" style="font-size: 20px;" style="font-family: Arial;">BV Type</label>
          <select class="form-select" id="billValidatorType-input"  formControlName="billValidatorType">
              <option *ngFor="let v of billValidatorType" [value]="v.id">{{v.name}}</option>
          </select>
        </div>   
        <div class="form-group">
          <label for="printerType-input" style="font-size: 20px;" style="font-family: Arial;">Printer Type</label>
          <select class="form-select" id="printerType-input"  formControlName="printerType">
              <option *ngFor="let v of printerType" [value]="v.id">{{v.name}}</option>
          </select>
        </div>   
        <div class="form-group">
          <label for="harnessType-input" style="font-size: 20px;" style="font-family: Arial;">Harness Type</label>
          <select class="form-select" id="harnessType-input"  formControlName="harnessType">
              <option *ngFor="let v of harnessType" [value]="v.id">{{v.name}}</option>
          </select>
        </div> 
        <div class="form-group">
          <label for="board-input" style="font-size: 20px;" style="font-family: Arial;">Board</label>
  
          <input id="board-input" class="form-control" list="board-list" formControlName="boardAssetTag"
            (change)="updateFilteredBoards(addEditFormGroup.get('boardAssetTag').value)"
          >
          <span aria-hidden="true"></span>
          <datalist id="board-list">
            <option *ngFor="let v of filteredBoards" value="{{v.assetTag}} - {{v.installedGamePackage?.name}}">
          </datalist>
        </div>  
        <div class="form-group">
          <label for="locations-input" style="font-size: 20px;" style="font-family: Arial;">Location Info</label>
  
          <input id="location-input" class="form-control" list="location-list" formControlName="locationTag"
            (change)="updateFilteredLocations(addEditFormGroup.get('locationTag').value)"
          >
          <span aria-hidden="true"></span>
          <datalist id="location-list">
            <option *ngFor="let v of filteredLocations" value="{{v.locationTag}} - {{v.locationName}}">
          </datalist>
        </div>
        <div class="form-group">
          <label for="purchased-input" style="font-size: 20px;" style="font-family: Arial;">Purchase Date</label>
          <input type="date" class="form-control" id="purchased-input" 
          formControlName="purchased"
          aria-describedby="purchased" placeholder="Enter Purchase Date">
        </div> 
        <div class="form-group">
          <label for="enabled-input" style="font-size: 20px;" style="font-family: Arial;">Enabled</label >
        
          <input type="checkbox" class="form-check-input" id="enabled-input"  style="height:25px;width:25px;"
            formControlName="enabled" >
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary btn-outline-dark" style="height:50px;width:200px;"(click)="modal.close('Save click')">Save</button>
    </div>
  </ng-template>
</div>